import styled from "styled-components"
import { typography } from "theme"

import { ButtonProps } from "components/buttons/shared"
import { textDecoration, FontConfigurations, textTransform } from "theme"
import { CTA } from "components/text"

export const ActionPrimaryButton = styled(CTA)<ButtonProps>`
  padding: ${props => props.theme.space[2]};
  border: 1px solid transparent;
  border-radius: 0.125rem;
  background-color: transparent;
  color: ${props => props.theme.colors.astralBlue};

  &:hover:not([disabled]):not(:active) {
    background: rgba(51, 122, 183, 0.05);
    border: 1px solid ${props => props.theme.colors.astralBlue};
  }

  &:active:not([disabled]) {
    background-color: ${props => props.theme.colors.astralBlue};
    color: ${props => props.theme.colors.white};
  }

  :disabled {
    color: ${props => props.theme.colors.silver};
    cursor: initial;
  }

  ${typography}
  ${textDecoration}
  ${textTransform}
`

ActionPrimaryButton.defaultProps = {
  as: "button",
  ...FontConfigurations.meta
}

export const ActionSecondaryButton = styled(CTA)<ButtonProps>`
  padding: 0.5rem;
  background-color: transparent;
  color: ${props => props.theme.colors.coolGrey};

  &:hover:not([disabled]):not(:active) {
    padding: ${props => props.theme.space[2]};
    background: rgba(151, 158, 157, 0.05);
    border: 1px solid ${props => props.theme.colors.coolGrey};
    border-radius: 0.125rem;
  }

  &:active:not([disabled]) {
    padding: ${props => props.theme.space[2]};
    border-radius: 0.125rem;
    background-color: ${props => props.theme.colors.coolGrey};
    color: ${props => props.theme.colors.white};
  }

  :disabled {
    color: ${props => props.theme.colors.silver};
    cursor: initial;
  }

  ${typography}
  ${textDecoration}
  ${textTransform}
`

ActionSecondaryButton.defaultProps = {
  as: "button",
  ...FontConfigurations.meta
}
